import { GetStoresService } from 'services';
export async function StorePopulate(page, text) {

  const stores = await GetStoresService(page, text);

  const getTotalPages = async () => {

   let itens = stores;

   const totalPages = itens ? itens.totalPages : 0;

   return totalPages;
  }

  const populate = async () => {

    let itens = stores;

    itens = itens ? itens.content : [];

    return itens.map(element => {

      const model = {
        id: {
          content: element.id,
          type: 'id'
        },
        name: {
          content: element.name,
          type: 'phrase',
        },
        link: {
          content: element.link,
          type: 'link',
        },
        clicksMonth: {
          content: element.totalInteractionsByStoreInMonth,
          type: 'clicks',
        },
        clicksTotal: {
          content: element.totalInteractionsByStore,
          type: 'clicks',
        },
        active: {
          content: element.enabled,
          type: 'switch'
        },
        action: {
          content: null,
          type: 'edit'
        }
      };

      return model;

    })
  }

  return { content: populate(), totalPage: getTotalPages()};
}
